<template>
	<vue-editor />
</template>
<script type="text/javascript">
	import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
	export default {
		components: { VueEditor }
	}
</script>
<style lang="css">
/*@import "~vue2-editor/dist/vue2-editor.css";

@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';*/
</style>